import { logger } from '@damofire/data-commons';
import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehouseIssuesStepsWorker } from '../workers/issues.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';

class WarehouseIssuesSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehouseIssuesStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseIssuesStepsWorker | Remote<WarehouseIssuesStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/issues.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehouseIssuesStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehouseIssuesStepsWorker()];
  }
}

export class WarehousePushIssuesSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `PUSH_ISS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing push issues sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseIssuesSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseDownloadIssuesSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_ISS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing download issues sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseIssuesSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseCleanIssuesSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `CLEAN_ISS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing clean issues sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseIssuesSyncWorkerFactory(), taskBreaker);
  }
}
